import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case types.MAP_MARKERS_LOAD_SUCCESS:
      return {
        ...state,
        mapData: actions.map_data,
      };

    case types.MAP_MARKERS_LOAD_FAILURE:
      return {
        ...state,
        mapData: undefined,
      };

    default:
      return state;
  }
}
